/**
 * The site's microphone permission, or null where the browser will not say.
 * Older Firefox and Safari throw on the name rather than answer.
 */
export async function queryMicrophonePermission(): Promise<PermissionStatus | null> {
  try {
    return await navigator.permissions.query({ name: 'microphone' });
  } catch {
    return null;
  }
}
